import React from "react";
import {motion} from "framer-motion";

const variants = {
    initial: {y: '-50vh', opacity: 1},
    animate: {y: 0, opacity: 1},
    exit: {opacity: 0.5}
}

export default function PageWrapper({children}: { children: React.ReactNode }) {
    return (
        <motion.div
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{duration: 0.4}}
            style={{
                position: 'relative',
                inset: 0,
                width: '100%',
                height: '100%',
                background: "transparent"
            }}>
            {children}
        </motion.div>
    );
}